export const VariantClasses = {
  primary: 'text-primary-600 hover:text-primary-500',
  secondary: 'text-gray-500 hover:text-gray-900',
  'gray-700': 'text-gray-700 hover:text-gray-500',
  'gray-900': 'text-gray-900 hover:text-gray-500',
}
